import { Callout, DefaultButton, DirectionalHint, Icon, Label, SearchBox, Stack, Text, } from "@fluentui/react";
import * as React from "react";
import { useMemo, useRef, useState } from "react";
import { buttonLabelStyles, buttonWrapperStyles, calloutContentStyles, chevronStyles, emptyMessageStyles, getDropdownButtonStyles, getItemStyles, listContainerStyles, } from "./SearchableDropdown.styles";
export const SearchableDropdown = ({ label, items, selectedItem, onSelect, getKey, getDisplayText, placeholder = "Select an item", filterPlaceholder = "Filter items", className, disabled = false, onDismiss, searchBoxStyles: customSearchBoxStyles, }) => {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const buttonRef = useRef(null);
    const closeDropdown = () => {
        setIsOpen(false);
        setFilterText("");
    };
    const filteredItems = useMemo(() => items === null || items === void 0 ? void 0 : items.filter((item) => getDisplayText(item).toLowerCase().includes(filterText.toLowerCase())), [items, filterText, getDisplayText]);
    const handleDismiss = () => {
        closeDropdown();
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    const handleButtonClick = () => {
        if (disabled) {
            return;
        }
        setIsOpen(!isOpen);
    };
    const handleSelect = (item) => {
        onSelect(item);
        closeDropdown();
    };
    const buttonLabel = selectedItem
        ? getDisplayText(selectedItem)
        : (items === null || items === void 0 ? void 0 : items.length) === 0
            ? `No ${label}s Found`
            : placeholder;
    const buttonId = `${className}-button`;
    const buttonStyles = getDropdownButtonStyles(disabled);
    return (React.createElement(Stack, null,
        React.createElement(Label, { htmlFor: buttonId }, label),
        React.createElement("div", { ref: buttonRef, style: buttonWrapperStyles },
            React.createElement(DefaultButton, { id: buttonId, className: className, onClick: handleButtonClick, styles: buttonStyles, disabled: disabled },
                React.createElement(Text, { styles: buttonLabelStyles }, buttonLabel)),
            React.createElement(Icon, { iconName: "ChevronDown", style: chevronStyles })),
        isOpen && (React.createElement(Callout, { target: buttonRef.current, onDismiss: handleDismiss, directionalHint: DirectionalHint.bottomLeftEdge, isBeakVisible: false, gapSpace: 0, setInitialFocus: true },
            React.createElement(Stack, { styles: calloutContentStyles, style: { width: ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 300 } },
                React.createElement(SearchBox, { placeholder: filterPlaceholder, value: filterText, onChange: (_, newValue) => setFilterText(newValue || ""), styles: customSearchBoxStyles, showIcon: true }),
                React.createElement(Stack, { styles: listContainerStyles }, filteredItems && filteredItems.length > 0 ? (filteredItems.map((item) => {
                    const key = getKey(item);
                    const isSelected = selectedItem ? getKey(selectedItem) === key : false;
                    return (React.createElement("div", { key: key, onClick: () => handleSelect(item), style: getItemStyles(isSelected), onMouseEnter: (e) => (e.currentTarget.style.backgroundColor = "#f3f2f1"), onMouseLeave: (e) => (e.currentTarget.style.backgroundColor = isSelected ? "#e6e6e6" : "transparent") },
                        React.createElement(Text, null, getDisplayText(item))));
                })) : (React.createElement(Text, { styles: emptyMessageStyles }, "No items found"))))))));
};
